// /pages/+onHydrationEnd.ts
// Environment: client

export { onHydrationEnd };

// The onHydrationEnd() hook is called after the onRenderClient() hook finishes rendering the
// first page the user navigates to. (The onHydrationEnd() hook isn't called upon subsequent
// page navigation.)
async function onHydrationEnd() {
  // Signal for e2e tests: `#root` existing only means the (possibly
  // server-rendered) markup is present, not that React has attached event
  // listeners yet. A click that lands in that gap is silently lost - see
  // cypress/support/step_definitions/global_steps.ts's `I visit the X page`
  // step, which waits on this before returning.
  (window as unknown as { __pageHydrated?: boolean }).__pageHydrated = true;
}
